export type NotFoundResponse = {
  meta: {
    code: 404;
    version: string;
  };
  errors: {
    code: string;
    description: string;
  }[];
};

export enum CrownRewardsErrorCodes {
  NonCrMember = 'err_non_cr_member',
  CrMemberLimitReached = 'err_cr_member_limit_reached',
  NonHplusSubscriber = 'err_non_h-plus_subscriber',
}
